import { getProfileId } from '@/utils/profile';

/**
 * Mixin listy akcji
 */
export const actionsMixin = {
  props: {
    // Obiekt zawierający dane
    object: {
      type: Object,
      required: true
    },
    // Możliwe do wykonania akcje
    actions: {
      type: Array,
      required: false,
      default: false
    },
    // Typ encji wyświetlanej w tabeli
    entityType: {
      type: String,
      required: false
    }
  },
  methods: {
    // @vuese
    // Pobiera uprawnienie przycisku akcji
    getPermissions(permissionsTypes) {
      return permissionsTypes.map(permissionType => `${this.entityType.toUpperCase()}.${permissionType}`);
    },

    // @vuese
    // Sprawdza, czy moduł jest zgodny
    checkModule(action) {
      if (action.module && this.object.status && this.object.status.stage && this.object.status.stage.module) {
        return this.object.status.stage.module.name === action.module;
      }
      return true;
    },

    // @vuese
    // Sprawdza, czy użytkownik jest twórcą dokumentu
    checkCreator(action) {
      if (!action.creatorOnly) {
        return true;
      }

      return this.object.creatorId === getProfileId();
    },

    // @vuese
    // Zwraca kolor akcji
    actionColor(action) {
      if (typeof action.color === 'function') {
        return action.color(this.object);
      }
      return action.color;
    }
  }
};
